import { usePersonalProfile } from '../entities/usePersonalProfile';
import { useProfile } from '../entities/useProfile';
import { useFilteredBalances } from './useFilteredBalances';
import { useInstrumentListWithDetails } from './useInstrumentListWithDetails';

/** @category Instruments */
export function useLiabilitiesTotal(vaultId?: string, profileId?: string) {
  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;
  const displayCurrencyCode = useProfile(profileId)?.displayCurrency;

  const balances =
    useFilteredBalances({
      profileId,
      vaultId,
      includeLiabilities: true,
      includeInactive: false,
    }) || [];

  const instruments = useInstrumentListWithDetails(
    [
      { currencyCode: displayCurrencyCode, amount: 0 },
      ...balances.map((balance) => balance.quantities?.issuedLiability),
    ],
    profileId,
  );

  // The first instrument in the array is always
  // a zero amount of the display currency
  return instruments.reduce((previous, next) =>
    previous.withQuantity({
      amount:
        previous.amount +
        (next.toDisplayCurrencyAmount({
          showUnconvertibleAmountAsZero: true,
        })?.amount || 0),
    }),
  );
}
